// src/router/index.js
import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import Tasks from '../views/Tasks.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: Tasks,
    // meta 字段用于标记该路由需要鉴权
    meta: { requiresAuth: true } 
  },
  {
    // 如果访问根路径或不存在的路径，重定向到任务页（守卫会判断是否放行）
    path: '*',
    redirect: '/tasks'
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

// 全局前置路由守卫 (核心逻辑)
router.beforeEach((to, from, next) => {
  // 从本地存储获取 Token
  const token = localStorage.getItem('token');

  // 去往登录页，清空 token 杜绝残留重连
  if (to.path === '/login') {
    localStorage.removeItem('token');
  }

  // 判断目标路由是否需要登录
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      // 需要登录但没 Token，打回登录页
      next({ path: '/login' });
    } else {
      // 有 Token，放行
      next();
    }
  } else {
    // 不需要登录的页面 (如 /login)，直接放行
    next();
  }
});

export default router;